import React, { FC }             from "react";
import { useDispatch, useStore } from "react-redux";
import { Button, Icon }          from "semantic-ui-react";
import UpdateOffice              from "../../../../application/usecase/office/UpdateOffice";
import Office                    from "../../../../domain/office/Office";

const OfficeUpdateButton: FC = () => {
  const office: Office = useStore().getState().office;
  const updateOffice: UpdateOffice = new UpdateOffice(useDispatch());

  return (
    <>
      <Button
        icon
        labelPosition="left"
        positive
        onClick={ () => updateOffice.execute(office) }
      >
        <Icon name="save"/>保存する
      </Button>
    </>
  );
};

export default OfficeUpdateButton;